import './index.scss';
import React from 'react';
import { toast } from 'react-semantic-toasts';
import { useTranslation } from 'react-i18next';
import { Message } from 'semantic-ui/semantic-ui-imports';
import ProjectList from 'components/ProjectList';
import { Result } from '../../../Types/Project';
import { getResults } from '../../../services/results';
import { useAuth } from '../../../contexts/auth';

const classId = 'offer-requests-page';

const OfferRequestsPage = () => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = React.useState<boolean>();
  const [results, setResults] = React.useState<Result[]>([]);
  const { user, isAuthenticated } = useAuth();

  const getObjs = async () => {
    setIsLoading(true);
    try {
      const r = await getResults({
        type: 'quote_request',
      });
      setResults(r?.results || []);
    } catch {
      toast({
        type: 'error',
        title: t('common.somethingWentWrong'),
        time: 4000,
        size: 'small',
      });
    }
    setIsLoading(false);
  };

  React.useEffect(() => {
    if (isAuthenticated && user) {
      getObjs();
    }
  }, [isAuthenticated, user]);

  return (
    <div className={`${classId}`}>
      {!isLoading && !results?.length && (
        <>
          <Message info compact>
            <Message.Header>{t('offerRequests.noRequests')}</Message.Header>
          </Message>
        </>
      )}
      {!!results && <h4>{t('offerRequests.header')}</h4>}
      <ProjectList projectType="quote_request" />
    </div>
  );
};

export default OfferRequestsPage;
